/* eslint-disable operator-linebreak */
// Login Page
export const DO_LOGIN = 'DO_LOGIN';
export const DO_LOGOUT = 'DO_LOGOUT';

// OTP Page
export const VERIFY_OTP = 'VERIFY_OTP';
export const RESEND_OTP = 'RESEND_OTP';

// User Tab
export const GET_USERS = 'GET_USERS';
export const RESET_USER_DETAILS = 'RESET_USER_DETAILS';
export const GET_USERS_DETAILS = 'GET_USERS_DETAILS';

// Places Tab
export const GET_PLACES = 'GET_PLACES';
export const RESET_PLACE_DETAILS = 'RESET_PLACE_DETAILS';
export const GET_PLACES_DETAILS = 'GET_PLACES_DETAILS';

export const GET_SPORTS = 'GET_SPORTS';

// Reported Users Tab
export const GET_REPORTED_USERS = 'GET_REPORTED_USERS';

// Referrals Tab
export const GET_REFERRALS = 'GET_REFERRALS';

// Notifications Tab
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';

// Chats Tab
export const GET_CHATS = 'GET_CHATS';

// Organizations Tab
export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';
export const RESET_ORGANIZATION_DETAILS = 'RESET_ORGANIZATION_DETAILS';
export const GET_ORGANIZATION_DETAILS = 'GET_ORGANIZATION_DETAILS';
export const GET_ORGANIZATION_BY_ID = 'GET_ORGANIZATION_BY_ID';
export const GET_ORGANIZATION_MEMBERS = 'GET_ORGANIZATION_MEMBERS';
export const GET_ORGANIZATION_PAYMENTS = 'GET_ORGANIZATION_PAYMENTS';

// Promo Codes Tab
export const GET_PROMOCODES = 'GET_PROMOCODES';
export const RESET_PROMOCODE_DETAILS = 'RESET_PROMOCODE_DETAILS';
export const ADD_PROMOCODE = 'ADD_PROMOCODE';
export const GET_PROMOCODE_DETAILS = 'GET_PROMOCODE_DETAILS';
export const GET_SPORTS_ASSOCIATED_USERS = 'GET_SPORTS_ASSOCIATED_USERS';

// Activities and Events Tab
export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_BY_ID = 'GET_EVENTS_BY_ID';
export const GET_EVENTS_USERS = 'GET_EVENTS_USERS';
export const RESET_ACTIVITIES_AND_EVENTS = 'RESET_ACTIVITIES_AND_EVENTS';
export const GET_EVENT_PARTICIPANTS_DETAILS = 'GET_EVENT_PARTICIPANTS_DETAILS';
export const GET_MANUAL_EVENT_RESULT_DETAIL = 'GET_MANUAL_EVENT_RESULT_DETAIL';
export const GET_RESULT_CATEGORIES_DETAIL = 'GET_RESULT_CATEGORIES_DETAIL';
export const GET_CATEGORY_DETAIL = 'GET_CATEGORY_DETAIL';

// Payments Tab
export const GET_PAYMENTS = 'GET_PAYMENTS';
export const GET_ACTIVITY_PAYMENTS = 'GET_ACTIVITY_PAYMENTS';
export const GET_EVENT_PAYMENTS = 'GET_EVENT_PAYMENTS';
export const GET_USER_PAYMENTS = 'GET_USER_PAYMENTS';
export const RESET_ACTIVITY_PAYMENTS_DETAILS =
  'RESET_ACTIVITY_PAYMENTS_DETAILS';
export const RESET_EVENT_PAYMENTS_DETAILS = 'RESET_EVENT_PAYMENTS_DETAILS';
export const RESET_USER_PAYMENTS_DETAILS = 'RESET_USER_PAYMENTS_DETAILS';
export const GET_EVENT_PARTICIPANTS_PAYMENT_DETAILS =
  'GET_EVENT_PARTICIPANTS_PAYMENT_DETAILS';
